// extracted by mini-css-extract-plugin
var _1 = "TagSection-module__container___XQN5O";
var _2 = "TagSection-module__labelText___U0L64";
var _3 = "TagSection-module__selectionChip___iRhc1";
var _4 = "TagSection-module__selectionChips___stpwW";
export { _1 as "container", _2 as "labelText", _3 as "selectionChip", _4 as "selectionChips" }
